import React from 'react';
import { ImportPatientEditTemplate } from 'themes/application/import/pages';
import { observer } from 'mobx-react';
import { ImportPatientEditViewStore } from 'application/import/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ImportPatientEditViewStore(rootStore), 'editView')
@observer
class ImportPatientEdit extends React.Component {
    render() {
        return <ImportPatientEditTemplate {...this.props} />
    }
}

export default ImportPatientEdit;